﻿window.VoterFly.UI = {

    getHeaderHeight() {
        return Math.ceil($('header nav.navbar-fixed-top').height());
    },

    /**
     * 
     * Creates an overlay and places the HTML content within the overlay
     * @param {any} html
     * @returns
     */
    overlay: function (elemOrHtml, opts) {

        let defaultOpts = {
            zIndex: null,
            blur: true,
            color: 'black'
        };

        const combinedOpts = { ...defaultOpts, ...opts };

        const $contentElement = $(`<div class="vf-overlay-content"></div>`);

        $contentElement.append(elemOrHtml);

        $overlay = $('<div class="vf-overlay" style="display:none;"></div>');
        $overlay.append($contentElement);

        $('body').append($overlay);

        let zIndex = combinedOpts.zIndex;

        // Try to get the zIndex from the first element
        if (!zIndex) {
            const $firstChild = $contentElement.children().first();
            zIndex = $firstChild.css('z-index');
        }

        if (zIndex && Number.isInteger(Number.parseInt(zIndex, 10))) {
            $overlay.css('z-index', parseInt(zIndex, 10) - 1);
        }

        $overlay.addClass(combinedOpts.color);

        if (combinedOpts.blur) {
            $overlay.addClass('blur');
        }

        $('html').addClass('vf-has-overlay');

        $overlay.show();

        return {
            $overlay: $overlay,

            hide() {
                this.$overlay.hide();
                this.$overlay.remove();
                this.$overlay = null;

                // If there are no more overlays in the page, remove the class vf-has-overlay
                if ($('.vf-overlay').length == 0) {
                    $('html').removeClass('vf-has-overlay');
                }
            }
        }
    },

    /**
     * Creates a dark overlay over the site directly beneath the element passed in.
     * @param {any} element
     */
    backdrop: function (element) {
        $element = $(element);
        let zIndex = $element.css('z-index');

        let $backdrop = $('#backdrop');

        if ($backdrop.length === 0) {
            $backdrop = $('<div id="backdrop" style="display:none;"></div>');

            $('body').append($backdrop);

            $backdrop = $('#backdrop');
        }

        $backdrop.addClass('active');
        $backdrop.css('z-index', parseInt(zIndex, 10) - 1);
        $backdrop.show();
    },

    /**
     * Hids any previously displayed backdrop
     * */
    hideBackdrop() {
        let $backdrop = $('#backdrop');
        $backdrop.removeClass('active');
        $backdrop.hide();
    },

    showModalFromUrl: function (url, preventFade) {
        var $modal = $($('#modal-script-template').html());

        if (preventFade) {
            $modal.removeClass('fade');
        }

        $.get(url, null, function (data) {
            $modal.find('.modal-content').html(data);

            var modalInstance = $modal.modal();
        })
    },

    /**
     * *
     * @param {any} title
     * @param {any} content
     * @param {any} buttons array of objects, [{ content : '', command : '', className : '' }]
     * @param {any} setupCallback a callback that gets an instance of the modal to wire up event handlers
     */
    showModal: function (title, content, buttons, preventFade, setupCallback) {
        var $modal = $($('#modal-script-template').html());

        $modal.find('.modal-title').html(title);
        $modal.find('.modal-body').html(content);

        if (preventFade) {
            $modal.removeClass('fade');
        }

        const $footer = $modal.find('.modal-footer');
        if (!buttons) {
            $footer.hide();
        } else {

            buttons.forEach(button => {
                const $btn = $('<button class="btn"></button>');
                $btn.html(button.content);

                if (button.command) {
                    $btn.data('command', button.command);
                }

                if (button.className) {
                    $btn.addClass(button.className);
                }

                $btn.on('click')

                $footer.append($btn);
            });
        }

        var modalInstance = $modal.modal();

        if (setupCallback) {
            setupCallback(modalInstance);
        }

        var promise = new Promise((resolve) => {
            $(modalInstance).on('click', '.modal-footer button', function (e) {
                const $btn = $(e.currentTarget);
                const command = $btn.data('command');
                resolve(command);
                $modal.modal('hide');
                $(modalInstance).off('click');
                $modal[0].remove();
            });

            $(modalInstance).on('hidden.bs.modal', function (e) {
                $(modalInstance).off('click');
                $modal[0].remove();
                resolve('close');
            });
        });

        return promise;
    },

    /**
     * Shows the "email-only" sign-in prompt used when a property allows unverified login.
     * Collects an email address and posts it to the server. On a successful sign-in the page is
     * reloaded (the user is now logged in); if the email belongs to a verified account the user is
     * redirected into the normal login so they prove ownership of the account.
     */
    showUnverifiedLoginModal: function () {
        var content = $('#tpl-unverified-login').html();

        VoterFly.UI.showModal('Enter your email to vote', content, null, false, function (modalInstance) {
            var $email = modalInstance.find('.unverified-login-email');
            var $error = modalInstance.find('.unverified-login-error');
            var $submit = modalInstance.find('.action-unverified-login-submit');
            var postUrl = $submit.data('post-url');

            function showError(message) {
                $error.text(message).show();
            }

            function submit() {
                var email = ($email.val() || '').trim();
                var emailIsValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

                if (!emailIsValid) {
                    showError('Please enter a valid email address.');
                    return;
                }

                $error.hide();
                $submit.addClass('disabled');

                $.post(postUrl, { email: email, returnUrl: window.location.href })
                    .done(function (data) {
                        if (data && data.redirectToLogin) {
                            window.location = data.loginUrl;
                            return;
                        }

                        window.location.reload();
                    })
                    .fail(function (jqXHR) {
                        $submit.removeClass('disabled');

                        var message = 'We could not sign you in. Please try again.';
                        if (jqXHR.responseJSON && jqXHR.responseJSON.error) {
                            message = jqXHR.responseJSON.error;
                        }

                        showError(message);
                    });
            }

            $submit.on('click', submit);

            $email.on('keypress', function (e) {
                if (e.which === 13) {
                    e.preventDefault();
                    submit();
                }
            });

            setTimeout(function () { $email.focus(); }, 150);
        });
    },

    showLoader: function (opts) {
        if (!opts) { opts = {}; }

        let $loadingOverlay = $('#loading-overlay');

        if ($loadingOverlay.length === 0) {
            $loadingOverlay = $(`
                <div id="loading-overlay" style="display:none;">
                    <span class="style-spinner-content">
                        <i class="fas fa-spinner fa-pulse loading-icon"></i>
                    </span>
                    <div class="style-percent-content"></div>
                </div>
            `);

            $('body').append($loadingOverlay);

            $loadingOverlay = $('#loading-overlay');
        }

        $loadingOverlay.removeClass('style-percent');
        $loadingOverlay.removeClass('style-spinner');

        if (opts.percent) {
            $loadingOverlay.addClass('style-percent');
        } else {
            $loadingOverlay.addClass('style-spinner');
        }

        $loadingOverlay.show();

        $pctContent = $loadingOverlay.find('.style-percent-content');

        return {
            setProgress: function (pct) {
                $pctContent.text(Math.round(pct) + '%');
            }
        }
    },

    hideLoader: function () {
        $('#loading-overlay').hide();
    },

    showMediaPopup: function (mediaUrl, mediaTitle, mediaDescription) {

        let $popup = $('#media-popup');

        if ($popup.length === 0) {
            const popupHtml = `
                <div id="media-popup">
                    <div class="contents">
                        <div class="image-holder">
                            <img class="img-responsive" />
                        </div>
                        <h4 class="title" />
                        <span class="description"></span>
                    </div>
                </div>`;

            $('body').append($(popupHtml));

            $popup = $('#media-popup');

            $popup.click(function () {
                $('body').css('overflow', 'auto');
                $popup.find('.image-holder img').attr('src', null);
                $popup.hide();
            });
        }

        $('body').css('overflow', 'hidden');
        $popup.removeClass('has-image');
        $popup.removeClass('has-description');

        $popup.find('.title').text(mediaTitle);

        $popup.find('.image-holder img').attr('src', mediaUrl);
        if (mediaUrl) { $popup.addClass('has-image'); }

        $popup.find('.description').text(mediaDescription);
        if (mediaDescription) { $popup.addClass('has-description'); }

        $popup.show();
    },

    loadAvatarImages: function ($targetElem) {
        $targetElem.find('img.avatar').each(function () {
            var $img = $(this);
            var image = new Image();

            image.onerror = function () {
                $img.attr('src', '/images/anonymous_person_icon.png');
            }

            image.onload = function () {
                $img.attr('src', image.src);
            }

            image.src = $(this).data('lazy-load-src');

            $img.attr('src', '/images/anonymous_person_icon.png');
        });
    }
};


(() => {
    const targetContainerId = 'view-messages';
    const defaultDelayMs = 2500;
    const delayIndefinitely = -1;

    const ViewMessages = {
        /**
        * A delayMs of -1 means to remain indefinitely 
        * @param {any} message
        * @param {any} level
        * @param {any} delayMs
        */
        addViewMessage(message, level, delayMs) {
            const viewMessagesContainer = document.getElementById(targetContainerId);
            var div = document.createElement('div');
            div.className = `view-message alert alert-${level}`;
            div.dataset.delayMs = delayMs ?? defaultDelayMs;

            // If the delay is indefinitely, allow the message to be dismissable.
            if (delayMs == delayIndefinitely) {
                div.className += ' alert-dismissible';
                div.innerHTML += ' <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>';
            }

            div.innerHTML += message;

            viewMessagesContainer.appendChild(div);

            ViewMessages.queueMessagesForCollapse();
        },

        addInfoMessage(message, delayMs) {
            ViewMessages.addViewMessage(message, 'info', delayMs || delayIndefinitely);
        },

        addSuccessMessage(message, delayMs) {
            ViewMessages.addViewMessage(message, 'success', delayMs || defaultDelayMs); // Disappears after a period of time
        },

        addWarningMessage(message, delayMs) {
            ViewMessages.addViewMessage(message, 'warning', delayMs || delayIndefinitely);
        },

        addDangerMessage(message, delayMs) {
            ViewMessages.addViewMessage(message, 'danger', delayMs || delayIndefinitely);
        },

        queueMessagesForCollapse() {
            /**
            * Collapse any view-message elements sequentially with a minor
            * 200ms delay in between each for smoothness
            */
            var $viewMessages = $('.view-message');
            $viewMessages.each((idx, elem) => {
                const handled = $(elem).data('handled');
                if (handled) {
                    return;
                }

                $(elem).data('handled', true);

                let delayMs = parseInt(elem.dataset.delayMs, 10);

                if (isNaN(delayMs)) delayMs = defaultDelayMs;

                if (delayMs == delayIndefinitely) {
                    return;
                }

                const extraSequentialMsDelay = idx * 200;

                // The more messages we have, the longer we should leave the bar up so the user can read it.
                const additionalDelayDuration = $viewMessages.length * 1000;
                const delayDuration = delayMs + additionalDelayDuration;

                $(elem).delay(delayDuration + extraSequentialMsDelay).slideUp(1000);
            });
        },

        /***
        * Takes the ModelState result from a BadRequest and displays it as a message
        */
        addBadRequestMessage(modelState, messagePreamble) {
            let errorMessage = messagePreamble ?? 'Validation Error:';

            let propertyMessages = [];
            // Iterate over each property in the modelState
            for (const property in modelState) {
                if (modelState.hasOwnProperty(property)) {
                    const errors = modelState[property];

                    // Optionally we could include the property name for a more specific error
                    // message, but that is also less user friendly.
                    propertyMessages.push(`<li>${errors.join(', ')}</li>`);
                }
            }

            errorMessage = `${errorMessage}<ul>${propertyMessages.join('')}</ul>`;

            // Display the error message
            ViewMessages.addDangerMessage(errorMessage, delayIndefinitely);
        },

        fromXHRApiResponse(xhrResponse) {
            var message = VoterFly.Util.getXHRApiResponseHtml('', xhrResponse);

            switch (xhrResponse.status) {
                case 200:
                case 201:
                case 202:
                    ViewMessages.addSuccessMessage(message);
                    break;

                default:
                    ViewMessages.addDangerMessage(message);
                    break;
            }
        }
    };

    window.VoterFly.UI.ViewMessages = ViewMessages;
})();